import React from "react";
import "./Home.css";

const HomeImg = () => {
  return (
    <div>
      <div className="homeimg_section">
        <div className="homeimg_image">
          <video loop autoPlay muted>
            <source src="/images/carouselvideo.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  );
};

export default HomeImg;
